import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { indexStore } from "../../store/indexStore";
import Visibility from "../../components/utils/Visibility";
import IsNotActive from "../../components/IsNotActive/IsNotActive";
import SelfBranchScreen from "../../components/BranchSecrens/SelfBranchScreen";
import NewBranchScreen from "../../components/BranchSecrens/NewBranchScreen";
import OldBranchScreen from "../../components/BranchSecrens/OldBranchScreen";
function Branch() {
  const {
    changeCategory,
    fetchMenusAction,

    fetchPriceOffersProducts,
  } = indexStore();
  const params = useParams();
  const paramsRequst = {
    domain: params.domain,
    branch_id: params.branch_id,
  };
  useEffect(() => {
    fetchMenusAction(paramsRequst).then(() => {
      fetchPriceOffersProducts({
        branch_id: params.branch_id,
        domain: params.domain,
      });
    });
    changeCategory(0);
  }, []);

  const screensToggle: number = 3;
  return (
    <IsNotActive>
      <title>{paramsRequst?.domain?.toUpperCase()}</title>

      <Visibility visible={screensToggle === 1}>
        <SelfBranchScreen />
      </Visibility>
      <Visibility visible={screensToggle === 2}>
        <OldBranchScreen />
      </Visibility>
      <Visibility visible={screensToggle === 3}>
        <NewBranchScreen />
      </Visibility>
    </IsNotActive>
  );
}

export default Branch;
